export const translationsParkingTilda = {
  ...{
    'tilda_tilda_parkings_cutouts--title': 'Kein Parken (Stanzungen) [TILDA]',
    'tilda_parkings_no--title': 'Kein Parken [TILDA]',
    'tilda_parkings--title': 'Parken [TILDA]',
    'tilda_parkings_cutouts--title': 'Stanzungen [TILDA]',
  },
  ...{
    // All parking tables use tilda_parkings as a prefix and share their translations.
    // If anything collides, we can use the more specific translations as well.
    'ALL--parking=half_on_kerb': 'Halb auf dem Bürgersteig',
    'ALL--parking=lane': 'Auf der Fahrbahn',
    'ALL--parking=no': 'Parken verboten',
    'ALL--parking=on_kerb': 'Auf dem Bürgersteig',
    'ALL--parking=shoulder': 'Seitensterifen',
    'ALL--parking=street_side': 'Parkbucht',
    'tilda_parkings_cutouts--buffer_radius--key': 'Radius der Stanzung',
    'tilda_parkings_cutouts--category--key': 'Stanzungen',
    'tilda_parkings_cutouts--category=advertising': 'Werbungtabeln u.ä.',
    'tilda_parkings_cutouts--category=barrier': 'Poller, Zaun, u.ä.',
    'tilda_parkings_cutouts--category=bicycle_parking': 'Fahrradparkplatz',
    'tilda_parkings_cutouts--category=bicycle_rental': 'Fahrradverleih',
    'tilda_parkings_cutouts--category=bollard': 'Poller',
    'tilda_parkings_cutouts--category=bus_stop_conditional': 'Bushaltestelle mit zeitlichen Einschränkungen (Nachtbusse, Schulbusse)',
    'tilda_parkings_cutouts--category=bus_stop': 'Bushaltestelle',
    'tilda_parkings_cutouts--category=crossing_buffer_marking': 'Markierung (Sperrfläche u.ä.) am Überweg',
    'tilda_parkings_cutouts--category=crossing_kerb_extension': 'Gehwegvorstreckung am Überweg',
    'tilda_parkings_cutouts--category=crossing_marked': 'Markierter Überweg',
    'tilda_parkings_cutouts--category=crossing_traffic_signals': 'Ampelübergang',
    'tilda_parkings_cutouts--category=crossing_zebra': 'Zebrastreifen',
    'tilda_parkings_cutouts--category=driveway_corner_kerb': 'Implizites Halteverbot am Beginn einer Einfahrt',
    'tilda_parkings_cutouts--category=driveway': 'Einfahrt',
    'tilda_parkings_cutouts--category=intersection_corner': 'Implizites Halteverbot an Straßenecke',
    'tilda_parkings_cutouts--category=kerb_lowered': 'Abgesenkter Bordstein',
    'tilda_parkings_cutouts--category=loading_ramp': 'Laderampe',
    'tilda_parkings_cutouts--category=mobility_hub': 'Mobilitätsstation',
    'tilda_parkings_cutouts--category=motorcycle_parking': 'Motorradparkplatz',
    'tilda_parkings_cutouts--category=parklet': 'Parklet',
    'tilda_parkings_cutouts--category=recycling': 'Recyclingstation',
    'tilda_parkings_cutouts--category=road_marking_restricted_area': 'Sperrfläche (Markierung)',
    'tilda_parkings_cutouts--category=small_electric_vehicle_parking': 'Parkplatz für kleine Elektrofahrzeuge wie E-Scootern',
    'tilda_parkings_cutouts--category=street_cabinet': 'Schaltkasten, Straßenkasten, u.ä.',
    'tilda_parkings_cutouts--category=street_lamp': 'Straßenlaterne',
    'tilda_parkings_cutouts--category=traffic_calming_choker': 'Angelegte Fahrbahnverengung',
    'tilda_parkings_cutouts--category=tree': 'Baum',
    'tilda_parkings_cutouts--category=turning_circle': 'Wendekreis – implizites Halteverbot',
    'tilda_parkings_cutouts--category=turning_loop': 'Wendeschleife – implizites Halteverbot ',
    'tilda_parkings_cutouts--category=vending_parking_tickets': 'Parkscheinautomat',
    'tilda_parkings_cutouts--source--key': 'Datenquelle',
    'tilda_parkings_cutouts--source=crossing': 'Überwege',
    'tilda_parkings_cutouts--source=driveway_corner_kerbs': 'Implizites Halteverbot am Beginn einer Einfahrt',
    'tilda_parkings_cutouts--source=driveways': 'Einfahrten',
    'tilda_parkings_cutouts--source=intersections': 'Kreuzungen',
    'tilda_parkings_cutouts--source=obstacle_areas': 'Flächige Hindernisse',
    'tilda_parkings_cutouts--source=obstacle_lines': 'Linienhafte Hindernisse',
    'tilda_parkings_cutouts--source=obstacle_points': 'Punktuelle Hindernisse',
    'tilda_parkings_cutouts--source=separate_parking_areas': 'Parkplätze die separat als Fläche erfasst sind',
    'tilda_parkings_cutouts--source=separate_parking_points': 'Parkplätze die separat als Punkt erfasst sind',
    'tilda_parkings_no--reason=capacity_below_zero': 'Abschnitt zu klein für ein Fahrzeug',
    'tilda_parkings--access--key': 'Zugang',
    'tilda_parkings--area_confidence=high': 'Hoch',
    'tilda_parkings--area_confidence=low': 'Niedrig',
    'tilda_parkings--area_confidence=medium': 'Mittel',
    'tilda_parkings--area_source=estimated': 'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
    'tilda_parkings--area_source=geometry': 'Basiert auf der Flächen aus OSM.',
    'tilda_parkings--area--key': 'Fläche',
    'tilda_parkings--authentication_disc--key': 'Parkscheibe',
    'tilda_parkings--capacity_confidence=high': 'Hoch',
    'tilda_parkings--capacity_confidence=low': 'Niedrig',
    'tilda_parkings--capacity_confidence=medium': 'Mittel',
    'tilda_parkings--capacity_source=area_and_orientation_diagonal_redistributed': 'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
    'tilda_parkings--capacity_source=area_and_orientation_diagonal': 'Berechnet auf Basis der Fläche und Parkausrichtung.',
    'tilda_parkings--capacity_source=area_and_orientation_fallback_parallel': 'Berechnet auf Basis der Fläche und Parkausrichtung. Allerdings war die Parkausrichtung unbekannt, so dass Parallelparken angenommen wurde.',
    'tilda_parkings--capacity_source=area_and_orientation_parallel_redistributed': 'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
    'tilda_parkings--capacity_source=area_and_orientation_parallel': 'Berechnet auf Basis der Fläche und Parkausrichtung.',
    'tilda_parkings--capacity_source=area_and_orientation_perpendicular_redistributed': 'Berechnet auf Basis der Fläche und Parkausrichtung, dann anteilig aufgeteilt nach Stanzung.',
    'tilda_parkings--capacity_source=area_and_orientation_perpendicular': 'Berechnet auf Basis der Fläche und Parkausrichtung.',
    'tilda_parkings--capacity_source=assumed_default': 'Keine explizite Angabe vorgefunden; dieser Wert ist eine Annahme.',
    'tilda_parkings--capacity_source=estimated_from_area': 'Berechnet auf Basis der Fläche und Ausrichtung.',
    'tilda_parkings--capacity_source=estimated_from_length': 'Berechnet auf Basis der Linien-Länge und Ausrichtung.',
    'tilda_parkings--capacity_source=estimated': 'Berechnung',
    'tilda_parkings--capacity_source=tag_redistributed': 'Explizite Angabe aus OSM, dann anteilig aufgeteilt nach Stanzung.',
    'tilda_parkings--capacity_source=tag': 'Explizite Angabe aus OSM.',
    'tilda_parkings--capacity--key': 'Kapazität',
    'tilda_parkings--charge--key': 'Ladestation',
    'tilda_parkings--condition_category--key': 'Parkbeschränkung',
    'tilda_parkings--condition_category=access_restriction': 'Zugangsbeschränkung',
    'tilda_parkings--condition_category=assumed_free': 'Wahrscheinlich keine Parkbeschränkungen',
    'tilda_parkings--condition_category=car_sharing': 'Nur für Carsharing-Fahrzeuge',
    'tilda_parkings--condition_category=charging': 'Laden von Elektrofahrzeugen',
    'tilda_parkings--condition_category=disabled_private': 'Behindertenparkplatz mit Parkausweis',
    'tilda_parkings--condition_category=disabled': 'Behindertenparkplatz',
    'tilda_parkings--condition_category=free': 'Keine Parkbeschränkungen',
    'tilda_parkings--condition_category=loading': 'Ladezone',
    'tilda_parkings--condition_category=no_parking': 'Parkverbot / Eingeschränktes Haltverbot',
    'tilda_parkings--condition_category=no_standing': 'Eingeschränktes Halteverbot',
    'tilda_parkings--condition_category=no_stopping': 'Halteverbot / Absolutes Haltverbot',
    'tilda_parkings--condition_category=paid': 'Nur mit Parkschein',
    'tilda_parkings--condition_category=residents': 'Nur mit Bewohnerparkausweis',
    'tilda_parkings--condition_category=taxi': 'Taxenstand',
    'tilda_parkings--condition_category=time_limited': 'zeitliche Beschränkung (Parkscheibe)',
    'tilda_parkings--condition_category=vehicle_restriction': 'Beschränkung auf/Verbot für ausgewiesene Fahrzeugklassen',
    'tilda_parkings--condition_vehicles--key': 'Fahrzeugbeschränkungen',
    'tilda_parkings--direction--key': 'Einparkrichtung',
    'tilda_parkings--disabled--key': 'Behindertenparkplatz',
    'tilda_parkings--fee--key': 'Gebühr',
    'tilda_parkings--fee=no': 'Kostenlos',
    'tilda_parkings--fee=yes': 'Kostenpflichtig',
    'tilda_parkings--hgv--key': 'Lkw',
    'tilda_parkings--markings--key': 'Markierungen',
    'tilda_parkings--markings=no': 'Ohne Markierungen',
    'tilda_parkings--markings=yes': 'Mit Markierungen',
    'tilda_parkings--maxstay_motorhome--key': 'Maximale Parkdauer Wohnmobil',
    'tilda_parkings--maxstay--key': 'Maximale Parkdauer',
    'tilda_parkings--motorcar--key': 'Pkw',
    'tilda_parkings--name--key': 'Straßenname',
    'tilda_parkings--operator_type--key': 'Betreibertyp',
    'tilda_parkings--orientation--key': 'Ausrichtung',
    'tilda_parkings--orientation=diagonal': 'Schrägparken',
    'tilda_parkings--orientation=parallel': 'Parallelparken',
    'tilda_parkings--orientation=perpendicular': 'Querparken',
    'tilda_parkings--parking--key': 'Parken',
    'tilda_parkings--private--key': 'Privat',
    'tilda_parkings--reason--key': 'Grund',
    'tilda_parkings--reason=missing_data': 'Keine Parkraum-Daten in OpenStreetMap erfasst',
    'tilda_parkings--reason=parking_tag': 'Explizite Angabe in den Daten',
    'tilda_parkings--restriction_bus--key': 'Bus Beschränkung',
    'tilda_parkings--restriction_hgv--key': 'LKW Beschränkung',
    'tilda_parkings--restriction_reason--key': 'Beschränkung Grund',
    'tilda_parkings--restriction--key': 'Beschränkung',
    'tilda_parkings--road_name--key': 'Straßenname',
    'tilda_parkings--road_oneway--key': 'Einbahnstraße',
    'tilda_parkings--road_width_confidence--key': 'Straßenbreite Vertrauen',
    'tilda_parkings--road_width_source--key': 'Straßenbreite Quelle',
    'tilda_parkings--road_width_source=highway_default_and_oneway': 'Standard-Wert für diesen Straßentyp als Einbahnstraße.',
    'tilda_parkings--road_width_source=highway_default': 'Standard-Wert für diesen Straßentyp.',
    'tilda_parkings--road_width_source=tag': 'Dieser Wert ist in OSM hinterlegt.',
    'tilda_parkings--road_width--key': 'Straßenbreite',
    'tilda_parkings--road--key': 'Straßentyp',
    'tilda_parkings--source--key': 'Datenquelle',
    'tilda_parkings--source=parkings': 'Angaben an der Straßenlinie',
    'tilda_parkings--source=separate_parking_areas': 'Separat erfasste Flächedaten',
    'tilda_parkings--source=separate_parking_points': 'Separate erfasste Punktdaten',
    'tilda_parkings--staggered--key': 'Parkweise',
    'tilda_parkings--staggered=yes--tooltip': 'Auf diesem Abschnitt gibt es keine Markierungen oder Schilder, die das Parken regeln. Häufig entwickelt sich eine Konvention zwischen den Anwohnenden, in welchen Bereichen auf welcher Seite geparkt wird. In der Kapazitätsberechnung fließt das ein: Die Kapazität wird um 50% reduziert (da nur eine Seite genutzt wird) und zusätzlich wird für jeden 60m-Abschnitt ein Manövrierraumverlust von 10m (≈1,9 Fahrzeugplätze) abgezogen, da beim Seitenwechsel Manövrierraum benötigt wird. Diese Angaben basieren auf Erfahrungswerten.',
    'tilda_parkings--staggered=yes': 'Alternierendes Parken',
    'tilda_parkings--taxi--key': 'Taxi',
    'tilda_parkings--zone--key': 'Zone',
  },
}
